import { createActions } from 'redux-actions';

export type State = {
  otpResetUrl?: string;
  errors: string[];
};

export type StateUpdatePayload = Partial<State>;

export const { otpTokenFetch, stateUpdate } = createActions('OTP_TOKEN_FETCH', 'STATE_UPDATE', {
  prefix: 'USER_DASHBOARD_OTP_LINK',
});
